<template>
  <div class="container">
    <h2 class="text-left" v-if="genres.length">Genres({{ genres.length }})</h2>
    <hr v-if="genres.length"/>
    <div class="grid-3_xs-1_sm-2_md-2" v-if="genres.length">
      <div
        v-for="(genre, index) in genres"
        :key="index"
        class="col"
      >
        <router-link v-if="genre.type === 'NORMAL'" :to="`/genre/${genre.name}`">
          <vs-card
            type="3"
            class="center"
          >
            <template #title>
              <h3>{{ genre.name }}</h3>
            </template>
            <template #text>
              <p>
                {{ genre.count }} post{{ `${genre.count >= 1 ? "s" : ""}` }}
              </p>
            </template>
          </vs-card>
        </router-link>
        <router-link v-else-if="genre.type === 'SERIES'" :to="`/series/${genre.name}`">
          <vs-card
            type="3"
            class="center"
          >
            <template #title>
              <h3>{{ genre.name }}</h3>
            </template>
            <template #text>
              <p>
                {{ genre.count }} post{{ `${genre.count >= 1 ? "s" : ""}` }}
              </p>
            </template>
          </vs-card>
        </router-link>
      </div>
    </div>

    <h2 class="text-left" v-if="tags.length">Tags({{ tags.length }})</h2>
    <hr v-if="tags.length"/>
    <div class="grid-5_xs-1_sm-2_md-2" v-if="tags.length">
      <div
        v-for="(tag, index) in tags"
        :key="index"
        class="col"
      >
        <router-link :to="`/tag/${tag.name}`">
          <vs-card
            type="3"
            class="center"
          >
            <template #title>
              <h3>{{ tag.name }}</h3>
            </template>
            <template #text>
              <p>
                {{ tag.count }} post{{ `${tag.count > 1 ? "s" : ""}` }}
              </p>
            </template>
          </vs-card>
        </router-link>
      </div>
    </div>
    <Nothing v-else />
  </div>
</template>

<script>
import Nothing from '@/components/Nothing.vue'
export default {
  name: 'ViewGenresTags',
  mounted: function () {
    this.changeTitle('Tags')
  },
  components: {
    Nothing
  },
  data () {
    return {
      genres: [],
      tags: []
    }
  },
  created () {
    this.request
      .GET('/genre/getAllGenres', {})
      .then((res) => {
        if (res.data) {
          this.genres = res.data
        }
      })

    this.request
      .GET('/genre/getAllTags', {})
      .then((res) => {
        if (res.data) {
          this.tags = res.data
        }
      })
  }
}
</script>
